var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8334 2C13.3857 2 13.8334 2.44772 13.8334 3V14.5858L17.1263 11.2929C17.5168 10.9024 18.15 10.9024 18.5405 11.2929C18.931 11.6834 18.931 12.3166 18.5405 12.7071L13.5405 17.7071C13.15 18.0976 12.5168 18.0976 12.1263 17.7071L7.12627 12.7071C6.73574 12.3166 6.73574 11.6834 7.12627 11.2929C7.51679 10.9024 8.14996 10.9024 8.54048 11.2929L11.8334 14.5858V3C11.8334 2.44772 12.2811 2 12.8334 2ZM5.83337 21C5.83337 20.4477 6.28109 20 6.83337 20H18.8334C19.3857 20 19.8334 20.4477 19.8334 21C19.8334 21.5523 19.3857 22 18.8334 22H6.83337C6.28109 22 5.83337 21.5523 5.83337 21Z",
    fill: "#939CB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d09cd513afe3274f80b5cec3726c58d6.svg";
export { ForwardRef as ReactComponent };